import useNameAttribute from "@hooks/attributes/useNameAttribute"
import useAttribute from "@hooks/useAttribute"

export default function useAttributes(
    salon: Model.Response<Jury.Resources.Salon>
): Jury.Models.Salon.Attrs {
    const name = useNameAttribute(salon)

    const awards = {
        options: useAwardsOptionsAttribute(salon),
        count: useAwardsCountAttribute(salon)
    }

    return {
        name,
        awards
    }
}

function useAwardsOptionsAttribute(salon: Model.Response<Jury.Resources.Salon>) {
    return useAttribute(salon.data, salon => {
        return salon.awards.map(award => ({ value: award.id.toString(), label: award.name }))
    }, [])
}

function useAwardsCountAttribute(salon: Model.Response<Jury.Resources.Salon>) {
    return useAttribute(salon.data, salon => {
        return salon.awards.reduce((count, award) => count + award.pivot.number, 0)
    }, 0)
}